import { useEffect, useState } from "react";
import API, { formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Sparkle, CircleNotch, Images } from "@phosphor-icons/react";

/* "Draft a scope for existing e-mail requests" / "Re-draft drafts using their photos" — start the background backfill and show progress. */
export default function InboxScopeBackfill({ enabled }) {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState("");
  const load = () => API.get("/inbox/ai/scope-backfill").then(({ data }) => setSt(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  useEffect(() => {
    if (!st?.running) return undefined;
    const t = setInterval(load, 3000);
    return () => clearInterval(t);
  }, [st?.running]);
  const run = async (mode) => {
    setBusy(mode);
    try { const { data } = await API.post("/inbox/ai/scope-backfill", { mode }); toast.success(data.message); setSt(data); }
    catch (e) { toast.error(formatApiError(e?.response?.data?.detail) || "Couldn't start"); } finally { setBusy(""); }
  };
  if (!st) return null;
  const nothing = !st.remaining && !st.photo_redraft_remaining;
  return (
    <div className="mt-2 flex flex-wrap items-center gap-2 text-xs" data-testid="inbox-scope-backfill">
      {st.running ? (
        <span className="inline-flex items-center gap-1.5 text-muted-foreground" data-testid="inbox-scope-backfill-progress"><CircleNotch size={12} className="animate-spin" /> {st.mode === "photos" ? "Re-drafting from photos…" : "Drafting…"} {st.drafted + st.skipped}/{st.total} done{st.skipped ? ` (${st.skipped} skipped)` : ""}</span>
      ) : nothing ? (
        <span className="text-muted-foreground" data-testid="inbox-scope-backfill-done">Every email request has a scope{st.finished_at ? ` — last run drafted ${st.drafted}` : ""}.</span>
      ) : (
        <>
          {st.remaining > 0 && <Button type="button" variant="outline" size="sm" className="h-7 text-xs" disabled={!!busy || !enabled} onClick={() => run("missing")} data-testid="inbox-scope-backfill-btn"><Sparkle size={12} className="mr-1" /> Draft for {st.remaining} existing email request{st.remaining === 1 ? "" : "s"} without a scope</Button>}
          {st.photo_redraft_remaining > 0 && <Button type="button" variant="outline" size="sm" className="h-7 text-xs" disabled={!!busy || !enabled} onClick={() => run("photos")} title="Unapproved AI drafts whose email or request has photos the AI hasn't looked at yet" data-testid="inbox-scope-photos-btn"><Images size={12} className="mr-1" /> Re-draft {st.photo_redraft_remaining} draft{st.photo_redraft_remaining === 1 ? "" : "s"} using {st.photo_redraft_remaining === 1 ? "its" : "their"} photos</Button>}
          {!enabled && <span className="text-muted-foreground">(switch AI scope on first)</span>}
        </>
      )}
    </div>
  );
}
